import fetch from 'isomorphic-unfetch'

interface IParams {
  /**
   * 超时时间
   */
  timeout?: number
}
type CustomFetch = (
  input: RequestInfo,
  init?: RequestInit
) => Promise<{
  [key: string]: any
}>
export default function createFetch({ timeout = 5000 }: IParams): CustomFetch {
  return (...args) => {
    const sendRequest: () => Promise<Response> = () => {
      return timeoutPromise<Response>(timeout, fetch(...args)).then(res => {
        if (!res.ok) {
          return Promise.reject(new Error('network_error'))
        }
        return res
      })
    }

    return sendRequest()
  }
}

/**
 * @param ms 超时时间
 * @param promise
 */
function timeoutPromise<T>(ms: number, promise: Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error('network_timeout'))
    }, ms)
    promise.then(resolve, reject)
  })
}
